import { FunctionComponent } from 'react'
import { ISubPage } from '../../prismicTypes'
import { getSubPageSEOData } from '../../utils/seoHelpers'
import NextHeader from '../NextHeader'
import SubpageHero from '../Hero/SubpageHero'
import SliceZone from '../slices/SliceZone'

interface IProps {
  page: ISubPage.IProps
}

const hasHeroData = (data: ISubPage.IData) => {
  let hasDescription = false
  let hasTitle = false

  if (data.description.length > 0 && (data.description[0].text?.length ? true : false)) {
    hasDescription = true
  }
  if (data.title != null && data.title.length > 0) {
    hasTitle = true
  }
  return hasDescription || hasTitle
}

const Subpage: FunctionComponent<IProps> = ({ page }: IProps) => {
  return (
    <>
      <NextHeader seoData={getSubPageSEOData(page)} />
      {hasHeroData(page.data) && <SubpageHero data={page.data} />}
      <SliceZone slices={page.data.body} />
    </>
  )
}

export default Subpage
